module.exports = "https://static.cdns.space/tarot-temp/img/blog3-7.d3ece137.png";